import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import {
  exportarFechamentoCicloOrcamentario,
  exportarFechamentoCicloOrcamentarioProjetoPacote,
  getFechamentoCicloAnoByFechamentoId,
} from '@app/api/fechamento';
import { CicloOrcamentarioRelatorio, Filtros } from '@app/api/relatorioCicloorcamentario';
import RelatorioCicloOrcamentarioTabela from '../RelatorioCicloOrcamentario/relatorioCicloOrcamentarioTabela';
import { hasPermission } from '@app/helpers/permissions';
const { Panel } = Collapse;

interface FechamentoCicloOrcamentarioProps {
  fechamentoId: string;
}

const FechamentoCicloOrcamentario = (props: FechamentoCicloOrcamentarioProps) => {
  const { fechamentoId } = props;

  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();

  useEffect(() => {
    if (fechamentoId) {
      getFechamentoCicloAnoByFechamentoId(fechamentoId).then(result => {
        setCicloOrcamentarioRelatorioTotal(result);
      });
    }
  }, [fechamentoId]);

  const btnExportar = () => {
    const btnResult = [];

    if (fechamentoId) {
      if (hasPermission(['FECHAMENTO_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
        btnResult.push(
          <Button
            type="primary"
            size={'small'}
            icon="files-ms_excel"
            onClick={() => {
              exportarFechamentoCicloOrcamentario(fechamentoId, 'exportarFechamentoCicloOrcamentario.xlsx');
            }}>
            Exporta Relatório
          </Button>,
        );
      }

      if (hasPermission(['FECHAMENTO_CICLO_ORCAMENTARIO_BOTAO_EXPORTA_RELATORIO_PROJETO_PACOTE_VISUALIZAR'])) {
        btnResult.push(
          <Button
            type="primary"
            size={'small'}
            icon="files-ms_excel"
            onClick={() => {
              exportarFechamentoCicloOrcamentarioProjetoPacote(fechamentoId, 'cicloOrcamentarioProjetoPacote.xlsx');
            }}>
            Exporta Relatório Projeto Pacote
          </Button>,
        );
      }
    }

    return btnResult;
  };

  return (
    <GridView noform>
      <Widget title="RESULTADO" span={12} actions={btnExportar()}>
        {cicloOrcamentarioRelatorioTotal && fechamentoId ? (
          <RelatorioCicloOrcamentarioTabela
            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
            filtro={{} as Filtros}
            mostrarColunaDetalhe={false}
            quantidadeItemPaginacao={10}
            mostrarColunaDetalheFechamento={true}
            fechamentoId={fechamentoId}
          />
        ) : (
          <> </>
        )}
      </Widget>
    </GridView>
  );
};

export default FechamentoCicloOrcamentario;
